export default __webpack_public_path__ + "static/media/ProjectBackground.04697b4b.jpeg";